import { PositionUrlConstant } from 'src/constants';
import { GetPositionListDto, GetPositionListResponseDto } from 'src/dtos';
import { WithAuthToken, replacePlaceholders, httpRequest } from 'src/utils';

export class PositionApi {
  list({ params, authToken }: WithAuthToken<GetPositionListDto>): Promise<GetPositionListResponseDto> {
    const { accountId } = params;

    const url = replacePlaceholders(PositionUrlConstant.LIST, { accountId });

    return httpRequest<GetPositionListResponseDto>({
      method: 'GET',
      url,
      authToken,
    });
  }
}
